module.exports = __webpack_public_path__ + "img/kodomo_syokudo.1ce03f63.png";